import { configApiRef, useApi } from '@backstage/core-plugin-api';
import useAsync from 'react-use/lib/useAsync';

import { RESOURCE_TYPES, recertificationApiRef } from '../api';
import { cadenceDaysFor, computeRowStatus, dueSoonDaysFor } from './status';

/**
 * Number of resources owned by the current user that are never recertified or expired.
 * Pass a changing `refreshKey` to refetch.
 */
export const useRecertificationDueCount = (refreshKey?: unknown): number => {
  const api = useApi(recertificationApiRef);
  const configApi = useApi(configApiRef);

  const { value } = useAsync(async () => {
    const dueSoon = dueSoonDaysFor(configApi);
    const results = await Promise.allSettled(
      RESOURCE_TYPES.map(async type => {
        const cadence = cadenceDaysFor(configApi, type);
        const rows = await api.listMine(type);
        return rows.filter(row => {
          const { kind } = computeRowStatus(row.lastRecertifiedOn, cadence, dueSoon);
          return kind === 'never' || kind === 'expired';
        }).length;
      }),
    );
    return results.reduce(
      (sum, r) => sum + (r.status === 'fulfilled' ? r.value : 0),
      0,
    );
  }, [api, configApi, refreshKey]);

  return value ?? 0;
};
